import { useEffect, useState,createContext,useMemo,useCallback } from "react";
import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../../common/hooks/useAuth";
import DashboardLayoutContainer from "../../pages/dashboard/components/main_layout";
import { useAxiosWithAuth } from "../../common/api/hooks/useAxiosWithAuth";
import { URL } from "../../common/api/urls";
import { BOOKMARK_CATEGORY_AUTOSAVE,BOOKMARKT_CATEGORY_DATA } from "../../common/utility/constant";
import { transformAndReverseMap, useQuery } from "../../common/utility/helperFunc";
import { syncUidataNotifyFlags } from "../../common/utility/contactVerifyNotify";
// ============================================================
// NEW - Centralized Permission System
// See: src/common/hooks/usePermissions.js
// ============================================================
import usePermissions from "../../common/hooks/usePermissions";

/**
 * Wrapper component to manage navigation based on user authentication status
 * @returns the route if the user is authenticated else it will redirect the user to login page
 */
//  export const UserSettingsContext = createContext({
//     userSettings: undefined,
//     setUserSettings: () => {},
//   });
export const UserSettingsContext = createContext({
    userSettings: undefined,
    setUserSettings: () => {},
    UIData: undefined,
    setUIData: () => {},
    headerData: undefined, //will have bookmark
    setHeaderData: () => {},
    notifData: undefined, // Notification data from backend
    setNotifData: () => {},
    showNotif: false, // Flag to control notification popup visibility
    setShowNotif: () => {},
    watchlists: undefined,
    setWatchlists: () => {},
    showWelcomeModal: false, // NEW Welcome modal state
    setShowWelcomeModal: () => {},
    showFreeToolsModal: false, // NEW free_tools modal state
    setShowFreeToolsModal: () => {},
    showOFWalkthroughCoach: false,
    setShowOFWalkthroughCoach: () => {},
    showMPChartWalkthrough: false,
    setShowMPChartWalkthrough: () => {},
    showMPWalkthroughCoach: false,
    setShowMPWalkthroughCoach: () => {},
    showMPSection: -1,
    setShowMPSection: () => {},
    showGlossaryCoach: false,
    setShowGlossaryCoach: () => {},
    showGlossaryPopup: false,
    setShowGlossaryPopup: () => {},
    showUserManualMarketingPopup: false,
    setShowUserManualMarketingPopup: () => {},
    showInfoPopup: false,
    setShowInfoPopup: () => {},
    infoPopupData: null,
    setInfoPopupData: () => {},
    toolsWalkthroughInitialId: "overview",
    openToolsWalkthrough: () => {},
    closeToolsWalkthrough: () => {},
    steelCardTool: null,
    setSteelCardTool: () => {},
});

const RequireAuth = ({allowedRoles,allowedResource}) => {
    const { auth, setAuth } = useAuth();
    const location = useLocation();
    const symbol = useQuery("symbol");
    // ============================================================
    // NEW - Centralized Permission System
    // Use permission service for role normalization and backward compatibility
    // ============================================================
    const permissions = usePermissions();
    
    const [userSettings, setUserSettings] = useState(undefined);
    const [isLoading, setIsLoading]=useState(true)
    const [cancel, responseData, error, loaded, reset, executeAPI ] = useAxiosWithAuth();
    const [cancelBookamrk, responseDataBookamrk, errorBookamrk, loadedBookamrk, resetBookamrk, executeAPIBookamrk ] = useAxiosWithAuth();
    const [cancelUIData,responseDataUIData, errorUIData, loadedUIData, resetUIData,executeAPIUIData ] = useAxiosWithAuth();
    const [isUIDataLoaded,setUIDataLoaded]=useState(false);
    const [UIData, setUIData] = useState(undefined);
    const [headerData, setHeaderData] = useState(undefined);
    const [instrumentTimeStamp, setInstrumentTimeStamp]=useState(undefined);
    const [notifData, setNotifData] = useState(undefined);
    const [showNotif, setShowNotif] = useState(false);
    //adding the watchlist also to the context so that no prop drilling would be required
    const [watchlists, setWatchlists] = useState(undefined);
    const [watchlistLoading, setWatchlistLoading] = useState(false);
    const [watchlistRefresh,setWatchlistRefresh]=useState(0)
    const [
        cancelWatchlist,
        watchlistResponse,
        watchlistError,
        watchlistLoaded,
        resetWatchlist,
        executeWatchlistAPI
    ] = useAxiosWithAuth();
    const [showWelcomeModal, setShowWelcomeModal] = useState(false);
//refresh watchlist to get the new instruments
    const refreshWatchlists = useCallback(() => {
        setWatchlistLoading(true);

        executeWatchlistAPI(
            URL.GET_WATCHLIST,
            "GET",
            {}
        );
    }, []);


const triggerWatchlistRefresh = () => {
    setWatchlistRefresh(v => v + 1);
};
const [showFreeToolsModal,setShowFreeToolsModal]=useState(false)
const [showToolsWalkthrough, setShowToolsWalkthrough] = useState(false);
//this coach will open a MpSection
const [showOFWalkthroughCoach, setShowOFWalkthroughCoach] = useState(false);
const [showMPChartWalkthrough, setShowMPChartWalkthrough] = useState(false);
const [showMPWalkthroughCoach, setShowMPWalkthroughCoach] = useState(false);

const [showMPSection, setShowMPSection] = useState(-1);
const [showGlossaryCoach, setShowGlossaryCoach] = useState(false);
const [showGlossaryPopup, setShowGlossaryPopup] = useState(false);
const [showUserManualMarketingPopup, setShowUserManualMarketingPopup] =
    useState(false);
const [showInfoPopup, setShowInfoPopup] = useState(false);
const [infoPopupData, setInfoPopupData] = useState(null);
const [toolsWalkthroughInitialId, setToolsWalkthroughInitialId] =
    useState("overview");
const [steelCardTool, setSteelCardTool] = useState(null);

const openToolsWalkthrough = useCallback((initialActiveId = "overview") => {
    setToolsWalkthroughInitialId(initialActiveId);
    setShowToolsWalkthrough(true);
}, []);

const closeToolsWalkthrough = useCallback(() => {
    setShowToolsWalkthrough(false);
    setToolsWalkthroughInitialId("overview");
}, []);
    const value = useMemo(
      () => ({ 
        userSettings, setUserSettings, 
        UIData, setUIData, 
        headerData, setHeaderData,
        notifData, setNotifData,
        showNotif, setShowNotif,
        watchlists, setWatchlists, watchlistLoading, 
        refreshWatchlists,watchlistRefresh,triggerWatchlistRefresh,
        showWelcomeModal, setShowWelcomeModal,   // NEW
        showToolsWalkthrough,setShowToolsWalkthrough,
        showFreeToolsModal,setShowFreeToolsModal,
        showOFWalkthroughCoach,setShowOFWalkthroughCoach,
        showMPChartWalkthrough,setShowMPChartWalkthrough,
        showMPWalkthroughCoach,setShowMPWalkthroughCoach,
        showMPSection,setShowMPSection,
        showGlossaryCoach,setShowGlossaryCoach,
        showGlossaryPopup,setShowGlossaryPopup,
        showUserManualMarketingPopup,setShowUserManualMarketingPopup,
        showInfoPopup,setShowInfoPopup,
        infoPopupData,setInfoPopupData,
        toolsWalkthroughInitialId,
        openToolsWalkthrough,
        closeToolsWalkthrough,
        steelCardTool,setSteelCardTool,
      }),
        [userSettings, UIData, headerData, notifData, showNotif, watchlists, watchlistLoading, watchlistRefresh, triggerWatchlistRefresh, showWelcomeModal, showToolsWalkthrough, showFreeToolsModal, showOFWalkthroughCoach, showMPChartWalkthrough, showMPWalkthroughCoach, showMPSection, showGlossaryCoach, showGlossaryPopup, showUserManualMarketingPopup, toolsWalkthroughInitialId, openToolsWalkthrough, closeToolsWalkthrough, steelCardTool]
  );

    // console.log("TestRefresh RequireAuth Auth,location=",auth,location);
      //get user settings at the start
      useEffect(()=>{
        // console.log("Aloowed roles in Require auth and auth object",allowedRoles,auth)
        if(auth?.accessToken){
          let data={
            "symbol": "NIFTY",
            "instruments": 1,
            "tpoList": 1,
             "additional_instruments": symbol?[symbol]:undefined,
            "dateList":1,
            "user_settings_form" : 1
          
          }

          if(instrumentTimeStamp!==undefined){
            data["instruments_ts"]=instrumentTimeStamp;
          }
          
          executeAPIUIData(URL.MPCHART_UIDATA,"POST",data); 
          executeAPIBookamrk(URL.GET_BOOKMARK_LIST,"GET",{});
          executeAPI(URL.USER_SETTING,"GET",{});
          // executeAPIBookamrk(URL.DELETE_ALL_AUTOSAVED_BOOKMARK,"DELETE",{});
          if(permissions.canAccessWatchlist()){
            refreshWatchlists()

          }
        }
        else{
            setUserSettings({})
            setIsLoading(false);
        }
      },[]);
useEffect(() => {

    if (!watchlistLoaded) return;

    if (watchlistResponse) {
        setWatchlists(watchlistResponse.data);
    }

    setWatchlistLoading(false);
    resetWatchlist();

}, [watchlistLoaded, watchlistResponse]);


       //api response handler UI Data
       useEffect(()=>{
        if(loadedUIData){
          // console.log("Require auth:loaded user settings ========>",responseData);
          if(responseDataUIData!=null){
            if(responseDataUIData.instruments){
              responseDataUIData.instruments = responseDataUIData.instruments.map((item) =>
                transformAndReverseMap(item)
              );
              setUIData(responseDataUIData);
              // localStorage.setItem('UIData', JSON.stringify(responseDataUIData));
              setUIDataLoaded(true);
            }

            if(responseDataUIData.instruments_ts){
              setInstrumentTimeStamp(responseDataUIData.instruments_ts);
            }

            // Contact verify + promo notif (promo display is gated behind contact in main_layout)
            if(responseDataUIData.notif === true && responseDataUIData.notif_data){
              console.log("Notification popup data received:", responseDataUIData.notif_data);
            }
            syncUidataNotifyFlags(
              responseDataUIData,
              setAuth,
              setNotifData,
              setShowNotif,
              {
                setPopupData: setInfoPopupData,
                setShowPopup: setShowInfoPopup,
              },
            );

           }else if(errorUIData!==null){
           
          }
        }
    
      },[loadedUIData,responseDataUIData, setAuth])
    
      //api response handler
      useEffect(()=>{
        if(loaded){
          // console.log("Require auth:loaded user settings ========>",responseData);
          if(responseData!=null){
            setUserSettings(responseData)
            localStorage.setItem('userSettings', JSON.stringify(responseData));
            const items = JSON.parse(localStorage.getItem('userSettings'));
            console.log("settings in local storage=",items);
            localStorage.setItem('auto_saved_links', JSON.stringify(responseData.data.auto_saved_links));
            
            setIsLoading(false);
           }else if(error!==null){
            setUserSettings({})
            setIsLoading(false);
          }
        }
    
      },[loaded,responseData])

      //api response handler
      useEffect(()=>{
        if(loadedBookamrk){
          // console.log("Require auth:loaded user settings ========>",responseData);
          if(responseDataBookamrk!=null){
            console.log("Bookmark response=",responseDataBookamrk,responseDataBookamrk.data,responseDataBookamrk.data.length)
            let bookmarkCategoryList=[...BOOKMARKT_CATEGORY_DATA];
            let bookmarkList=[];
            for(let i=0;i<responseDataBookamrk.data.length;i++){
              if(responseDataBookamrk.data[i].category!=BOOKMARK_CATEGORY_AUTOSAVE){
                bookmarkList.push(responseDataBookamrk.data[i])
                // if(!bookmarkCategoryList.some(item=>item.category==responseDataBookamrk.data[i].category)){
                  if (!bookmarkCategoryList.find(e => e.name === responseDataBookamrk.data[i].category)) {
                bookmarkCategoryList.push({
                  name:responseDataBookamrk.data[i].category,
                  value:responseDataBookamrk.data[i].category
                })
              }
              }
            }
            if(bookmarkCategoryList.length>0){
              
              localStorage.setItem('bookmark_category', JSON.stringify(bookmarkCategoryList));
              localStorage.setItem("bookmark_list",JSON.stringify(bookmarkList));
            }
          
           }else if(errorBookamrk!==null){
            // setUserSettings({})
            // setIsLoading(false);
          }
        }
    
      },[loadedBookamrk,responseDataBookamrk])

      
      
       // ============================================================
       // NEW - Use centralized permission service for role checking
       // Uses role matrix system with new role names (basic, premium, pro1)
       // ============================================================
       const hasRoleAccess = allowedRoles === undefined || allowedRoles.length === 0 
         ? true 
         : permissions.hasAccess(allowedRoles, undefined);
       const hasResourceAccess = allowedResource === undefined 
         ? true 
         : (Array.isArray(allowedResource) 
             ? permissions.hasAnyResource(allowedResource) 
             : permissions.hasResource(allowedResource));
       
       if (!auth?.accessToken) {
           return null;
       }

       if (!hasRoleAccess || !hasResourceAccess) {
           return (
               <Navigate to="/unauthorized" state={{ from: location }} replace />
           );
       }

       return (
        userSettings!=undefined && isUIDataLoaded && !isLoading?
                <UserSettingsContext.Provider value={value}>
                    <DashboardLayoutContainer>
                        <Outlet />
                    </DashboardLayoutContainer>
                </UserSettingsContext.Provider>
                : <></>
    );
}

export default RequireAuth;